import { render, staticRenderFns } from "./PXSurveyProcessPreviewPage.vue?vue&type=template&id=3bd4f005&scoped=true"
import script from "./PXSurveyProcessPreviewPage.vue?vue&type=script&lang=js"
export * from "./PXSurveyProcessPreviewPage.vue?vue&type=script&lang=js"
import style0 from "./PXSurveyProcessPreviewPage.vue?vue&type=style&index=0&id=3bd4f005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4f005",
  null
  
)

export default component.exports